export default __webpack_public_path__ + "6dba74bc2940fb319a39ba473d4cec35.png";